import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/app/homepage/components/GlobalPresenceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/components/ui/AppImage.tsx");
